import { extend } from "vee-validate";
import { required, size, email, max } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: "{_field_} is required"
});

extend("max", {
  ...max,
  message: (fieldName, params) => {
    return `${fieldName} must be no more than ${params ? params["length"] : 0} characters`;
  }
});

extend("size", {
  ...size,
  message: (fieldName, placeholders) => {
    placeholders = placeholders || {};
    return `${fieldName} must be less than ${placeholders["size"] / 1024}MB`;
  }
});

extend("email", {
  ...email,
  message: fieldName => {
    return `${fieldName} must be a valid email address`;
  }
});

export const AUSTRALIANMOBILEREG = /^(\+?(61))? ?0?(4|5)\d{2} ?\d{3} ?\d{3}$/;
export const AUSTRALIANLANDLINENUMBERREG = /^(\+?(61))? ?(02|03|07|08|2|3|7|8)? ?\d{4} ?\d{4}$/;
export const AUSTRALIANONETHREEHUNDREDNUMBERREG = /^(\+?(61))? ?(1300) ?\d{3} ?\d{3}$/;

extend("phoneNumber", {
  message: fieldName => {
    return `Please either a valid ${fieldName}`;
  },
  validate: value => {
    if (AUSTRALIANMOBILEREG.test(value) || AUSTRALIANLANDLINENUMBERREG.test(value) || AUSTRALIANONETHREEHUNDREDNUMBERREG.test(value)) {
      return true;
    }

    return false;
  }
});
